<template>
  <transition name="slide">
    <div class="project-update">
      <div class="wizard-toolbar">
        <div class="grid-2">
          <div class="progress-step-1 active">
            <div class="bar"></div>
            <p>{{ $t("ui.project_wizard.step1-title") }}</p>
          </div>

          <div class="progress-step-2 inactive">
            <div class="bar"></div>
            <p>{{ $t("ui.project_wizard.step2-title") }}</p>
          </div>
        </div>
      </div>

      <h2>{{ $t("ui.project_wizard.step1-title") }}</h2>

      <form class="project-update--form" @submit.prevent>
        <field
          :errors="errors"
          :required="true"
          model="project"
          name="name"
          v-model="item.name"
          placeholder="Tech con 2016"
        ></field>
      </form>

      <div class="actions wizard-footer">
        <a class="cancel" @click="cancel()">{{ $t("ui.global.cancel") }}</a>
        <button class="btn btn-primary btn-flat btn-save" @click="nextStep()">
          {{ $t("ui.pages.project-next-button") }}
        </button>
      </div>
    </div>
  </transition>
</template>
<script>
import Field from "@/components/helpers/DataInput/Field";

export default {
  components: {
    Field
  },
  props: {
    item: {
      type: Object
    }
  },
  computed: {
    errors() {
      return this.$store.getters.getProjectWizardErrors;
    }
  },
  methods: {
    cancel() {
      this.$store.commit("RESET_PROJECT_WIZARD_ERRORS");
      this.$store.commit("SET_PROJECT_WIZARD_STEP", 1);
      this.$router.push({
        name: "projects"
      });
    },
    nextStep() {
      let valid = this.validate();
      if (valid) {
        // Go to next step
        this.$store.commit("INCREMENT_PROJECT_WIZARD_STEP", 1);
      }
    },
    validate() {
      this.$store.commit("RESET_PROJECT_WIZARD_ERRORS");
      if (!this.item.name) {
        this.$store.commit("ADD_PROJECT_WIZARD_ERROR", {
          field_name: "name",
          code: `project.name.invalid`
        });
      }
      return this.errors.length == 0;
    }
  }
};
</script>
<style lang="scss" scoped>
.actions {
  text-align: right;
  margin-top: 20px;
}
.step-1 {
  .project-update--form {
    padding: 10px 40px 5px 40px;
  }
}
</style>
<style lang="scss"></style>



// WEBPACK FOOTER //
// StepOne.vue?d288ea38